import React from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";
import { getUsersChosenUsLabel } from "../../../../../const/SocialProof";

export const PcEmail = ({ setEmail, email, isCurPage, inputRef }) => {

  return (
    <div className="email-pc" data-model-id="16867:12569">
      <div className="contents">
        <div className="title">
          <p className="heading">
            Enter your email to get your personal weight loss plan
          </p>
        </div>

        <div className="frame">
          <div className="list">
            <div className="date-picker">
              <input ref={inputRef} className="email-pc-input"

                     enterKeyHint="done"
                     type={"email"}
                     placeholder={"Enter your email to get your plan"}
                     onChange={(e) => { setEmail(e.target.value)}} value={email}
              />
            </div>
          </div>

          <div className="discount">
            <Image src="/static/image/questionnaire/fasting/email/pc/icon.svg" alt="Icon" className="icon" />

            <p className="user-count">{getUsersChosenUsLabel()}</p>
          </div>

          <div className="email-pc-privacy">
            <Image src="/static/image/questionnaire/fasting/email/pc/lock.svg" alt="Lock" className="lock" />

            <p className="privacy-statement">
              We respect your privacy and are committed to protecting your
              personal data. We&#39;ll email you a copy of your results for
              convenient access.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
